export default {
  paises: [
    { value: 'Afghanistan (‫افغانستان‬‎)', text: 'Afghanistan' },
    { value: 'Albania (Shqipëri)', text: 'Albania' },
    { value: 'Algeria (‫الجزائر‬‎)', text: 'Algeria' },
    { value: 'American Samoa', text: 'American Samoa' },
    { value: 'Andorra', text: 'Andorra' },
    { value: 'Angola', text: 'Angola' },
    { value: 'Anguilla', text: 'Anguilla' },
    { value: 'Antigua and Barbuda', text: 'Antigua and Barbuda' },
    { value: 'Argentina', text: 'Argentina' },
    { value: 'Armenia (Հայաստան)', text: 'Armenia' },
    { value: 'Aruba', text: 'Aruba' },
    { value: 'Australia', text: 'Australia' },
    { value: 'Austria (Österreich)', text: 'Austria' },
    { value: 'Azerbaijan (Azərbaycan)', text: 'Azerbaijan' },
    { value: 'Bahamas', text: 'Bahamas' },
    { value: 'Bahrain (‫البحرين‬‎)', text: 'Bahrain' },
    { value: 'Bangladesh (বাংলাদেশ)', text: 'Bangladesh' },
    { value: 'Barbados', text: 'Barbados' },
    { value: 'Belarus (Беларусь)', text: 'Belarus' },
    { value: 'Belgium (België)', text: 'Belgium' },
    { value: 'Belize', text: 'Belize' },
    { value: 'Benin (Bénin)', text: 'Benin' },
    { value: 'Bermuda', text: 'Bermuda' },
    { value: 'Bhutan (འབྲུག)', text: 'Bhutan' },
    { value: 'Bolivia', text: 'Bolivia' },
    { value: 'Bosnia and Herzegovina (Босна и Херцеговина)', text: 'Bosnia and Herzegovina' },
    { value: 'Botswana', text: 'Botswana' },
    { value: 'Brazil (Brasil)', text: 'Brazil' },
    { value: 'British Indian Ocean Territory', text: 'British Indian Ocean Territory' },
    { value: 'British Virgin Islands', text: 'British Virgin Islands' },
    { value: 'Brunei', text: 'Brunei' },
    { value: 'Bulgaria (България)', text: 'Bulgaria' },
    { value: 'Burkina Faso', text: 'Burkina Faso' },
    { value: 'Burundi (Uburundi)', text: 'Burundi' },
    { value: 'Cambodia (កម្ពុជា)', text: 'Cambodia' },
    { value: 'Cameroon (Cameroun)', text: 'Cameroon' },
    { value: 'Canada', text: 'Canada' },
    { value: 'Cape Verde (Kabu Verdi)', text: 'Cape Verde' },
    { value: 'Caribbean Netherlands', text: 'Caribbean Netherlands' },
    { value: 'Cayman Islands', text: 'Cayman Islands' },
    { value: 'Central African Republic (République centrafricaine)', text: 'Central African Republic' },
    { value: 'Chad (Tchad)', text: 'Chad' },
    { value: 'Chile', text: 'Chile' },
    { value: 'China (中国)', text: 'China' },
    { value: 'Christmas Island', text: 'Christmas Island' },
    { value: 'Cocos (Keeling) Islands', text: 'Cocos (Keeling) Islands' },
    { value: 'Colombia', text: 'Colombia' },
    { value: 'Comoros (‫جزر القمر‬‎)', text: 'Comoros' },
    { value: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', text: 'Congo (DRC)' },
    { value: 'Congo (Republic) (Congo-Brazzaville)', text: 'Congo (Republic)' },
    { value: 'Cook Islands', text: 'Cook Islands' },
    { value: 'Costa Rica', text: 'Costa Rica' },
    { value: 'Côte d’Ivoire', text: 'Côte d’Ivoire' },
    { value: 'Croatia (Hrvatska)', text: 'Croatia' },
    { value: 'Cuba', text: 'Cuba' },
    { value: 'Curaçao', text: 'Curaçao' },
    { value: 'Cyprus (Κύπρος)', text: 'Cyprus' },
    { value: 'Czech Republic (Česká republika)', text: 'Czech Republic' },
    { value: 'Denmark (Danmark)', text: 'Denmark' },
    { value: 'Djibouti', text: 'Djibouti' },
    { value: 'Dominica', text: 'Dominica' },
    { value: 'Dominican Republic (República Dominicana)', text: 'Dominican Republic' },
    { value: 'Ecuador', text: 'Ecuador' },
    { value: 'Egypt (‫مصر‬‎)', text: 'Egypt' },
    { value: 'El Salvador', text: 'El Salvador' },
    { value: 'Equatorial Guinea (Guinea Ecuatorial)', text: 'Equatorial Guinea' },
    { value: 'Eritrea', text: 'Eritrea' },
    { value: 'Estonia (Eesti)', text: 'Estonia' },
    { value: 'Ethiopia', text: 'Ethiopia' },
    { value: 'Falkland Islands (Islas Malvinas)', text: 'Falkland Islands' },
    { value: 'Faroe Islands (Føroyar)', text: 'Faroe Islands' },
    { value: 'Fiji', text: 'Fiji' },
    { value: 'Finland (Suomi)', text: 'Finland' },
    { value: 'France', text: 'France' },
    { value: 'French Guiana (Guyane française)', text: 'French Guiana' },
    { value: 'French Polynesia (Polynésie française)', text: 'French Polynesia' },
    { value: 'Gabon', text: 'Gabon' },
    { value: 'Gambia', text: 'Gambia' },
    { value: 'Georgia (საქართველო)', text: 'Georgia' },
    { value: 'Germany (Deutschland)', text: 'Germany' },
    { value: 'Ghana (Gaana)', text: 'Ghana' },
    { value: 'Gibraltar', text: 'Gibraltar' },
    { value: 'Greece (Ελλάδα)', text: 'Greece' },
    { value: 'Greenland (Kalaallit Nunaat)', text: 'Greenland' },
    { value: 'Grenada', text: 'Grenada' },
    { value: 'Guadeloupe', text: 'Guadeloupe' },
    { value: 'Guam', text: 'Guam' },
    { value: 'Guatemala', text: 'Guatemala' },
    { value: 'Guernsey', text: 'Guernsey' },
    { value: 'Guinea (Guinée)', text: 'Guinea' },
    { value: 'Guinea-Bissau (Guiné Bissau)', text: 'Guinea-Bissau' },
    { value: 'Guyana', text: 'Guyana' },
    { value: 'Haiti', text: 'Haiti' },
    { value: 'Honduras', text: 'Honduras' },
    { value: 'Hong Kong (香港)', text: 'Hong Kong' },
    { value: 'Hungary (Magyarország)', text: 'Hungary' },
    { value: 'Iceland (Ísland)', text: 'Iceland' },
    { value: 'India (भारत)', text: 'India' },
    { value: 'Indonesia', text: 'Indonesia' },
    { value: 'Iran (‫ایران‬‎)', text: 'Iran' },
    { value: 'Iraq (‫العراق‬‎)', text: 'Iraq' },
    { value: 'Ireland', text: 'Ireland' },
    { value: 'Isle of Man', text: 'Isle of Man' },
    { value: 'Israel (‫ישראל‬‎)', text: 'Israel' },
    { value: 'Italy (Italia)', text: 'Italy' },
    { value: 'Jamaica', text: 'Jamaica' },
    { value: 'Japan (日本)', text: 'Japan' },
    { value: 'Jersey', text: 'Jersey' },
    { value: 'Jordan (‫الأردن‬‎)', text: 'Jordan' },
    { value: 'Kazakhstan (Казахстан)', text: 'Kazakhstan' },
    { value: 'Kenya', text: 'Kenya' },
    { value: 'Kiribati', text: 'Kiribati' },
    { value: 'Kosovo', text: 'Kosovo' },
    { value: 'Kuwait (‫الكويت‬‎)', text: 'Kuwait' },
    { value: 'Kyrgyzstan (Кыргызстан)', text: 'Kyrgyzstan' },
    { value: 'Laos (ລາວ)', text: 'Laos' },
    { value: 'Latvia (Latvija)', text: 'Latvia' },
    { value: 'Lebanon (‫لبنان‬‎)', text: 'Lebanon' },
    { value: 'Lesotho', text: 'Lesotho' },
    { value: 'Liberia', text: 'Liberia' },
    { value: 'Libya (‫ليبيا‬‎)', text: 'Libya' },
    { value: 'Liechtenstein', text: 'Liechtenstein' },
    { value: 'Lithuania (Lietuva)', text: 'Lithuania' },
    { value: 'Luxembourg', text: 'Luxembourg' },
    { value: 'Macau (澳門)', text: 'Macau' },
    { value: 'Macedonia (FYROM) (Македонија)', text: 'Macedonia (FYROM)' },
    { value: 'Madagascar (Madagasikara)', text: 'Madagascar' },
    { value: 'Malawi', text: 'Malawi' },
    { value: 'Malaysia', text: 'Malaysia' },
    { value: 'Maldives', text: 'Maldives' },
    { value: 'Mali', text: 'Mali' },
    { value: 'Malta', text: 'Malta' },
    { value: 'Marshall Islands', text: 'Marshall Islands' },
    { value: 'Martinique', text: 'Martinique' },
    { value: 'Mauritania (‫موريتانيا‬‎)', text: 'Mauritania' },
    { value: 'Mauritius (Moris)', text: 'Mauritius' },
    { value: 'Mayotte', text: 'Mayotte' },
    { value: 'Mexico (México)', text: 'Mexico' },
    { value: 'Micronesia', text: 'Micronesia' },
    { value: 'Moldova (Republica Moldova)', text: 'Moldova' },
    { value: 'Monaco', text: 'Monaco' },
    { value: 'Mongolia (Монгол)', text: 'Mongolia' },
    { value: 'Montenegro (Crna Gora)', text: 'Montenegro' },
    { value: 'Montserrat', text: 'Montserrat' },
    { value: 'Morocco (‫المغرب‬‎)', text: 'Morocco' },
    { value: 'Mozambique (Moçambique)', text: 'Mozambique' },
    { value: 'Myanmar (Burma) (မြန်မာ)', text: 'Myanmar (Burma)' },
    { value: 'Namibia (Namibië)', text: 'Namibia' },
    { value: 'Nauru', text: 'Nauru' },
    { value: 'Nepal (नेपाल)', text: 'Nepal' },
    { value: 'Netherlands (Nederland)', text: 'Netherlands' },
    { value: 'New Caledonia (Nouvelle-Calédonie)', text: 'New Caledonia' },
    { value: 'New Zealand', text: 'New Zealand' },
    { value: 'Nicaragua', text: 'Nicaragua' },
    { value: 'Niger (Nijar)', text: 'Niger' },
    { value: 'Nigeria', text: 'Nigeria' },
    { value: 'Niue', text: 'Niue' },
    { value: 'Norfolk Island', text: 'Norfolk Island' },
    { value: 'North Korea (조선 민주주의 인민 공화국)', text: 'North Korea' },
    { value: 'Northern Mariana Islands', text: 'Northern Mariana Islands' },
    { value: 'Norway (Norge)', text: 'Norway' },
    { value: 'Oman (‫عُمان‬‎)', text: 'Oman' },
    { value: 'Pakistan (‫پاکستان‬‎)', text: 'Pakistan' },
    { value: 'Palau', text: 'Palau' },
    { value: 'Palestine (‫فلسطين‬‎)', text: 'Palestine' },
    { value: 'Panama (Panamá)', text: 'Panama' },
    { value: 'Papua New Guinea', text: 'Papua New Guinea' },
    { value: 'Paraguay', text: 'Paraguay' },
    { value: 'Peru (Perú)', text: 'Peru' },
    { value: 'Philippines', text: 'Philippines' },
    { value: 'Poland (Polska)', text: 'Poland' },
    { value: 'Portugal', text: 'Portugal' },
    { value: 'Puerto Rico', text: 'Puerto Rico' },
    { value: 'Qatar (‫قطر‬‎)', text: 'Qatar' },
    { value: 'Réunion (La Réunion)', text: 'Réunion' },
    { value: 'Romania (România)', text: 'Romania' },
    { value: 'Russia (Россия)', text: 'Russia' },
    { value: 'Rwanda', text: 'Rwanda' },
    { value: 'Saint Barthélemy', text: 'Saint Barthélemy' },
    { value: 'Saint Helena', text: 'Saint Helena' },
    { value: 'Saint Kitts and Nevis', text: 'Saint Kitts and Nevis' },
    { value: 'Saint Lucia', text: 'Saint Lucia' },
    { value: 'Saint Martin (Saint-Martin (partie française))', text: 'Saint Martin' },
    { value: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', text: 'Saint Pierre and Miquelon' },
    { value: 'Saint Vincent and the Grenadines', text: 'Saint Vincent and the Grenadines' },
    { value: 'Samoa', text: 'Samoa' },
    { value: 'San Marino', text: 'San Marino' },
    { value: 'São Tomé and Príncipe (São Tomé e Príncipe)', text: 'São Tomé and Príncipe' },
    { value: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)', text: 'Saudi Arabia' },
    { value: 'Senegal (Sénégal)', text: 'Senegal' },
    { value: 'Serbia (Србија)', text: 'Serbia' },
    { value: 'Seychelles', text: 'Seychelles' },
    { value: 'Sierra Leone', text: 'Sierra Leone' },
    { value: 'Singapore', text: 'Singapore' },
    { value: 'Sint Maarten', text: 'Sint Maarten' },
    { value: 'Slovakia (Slovensko)', text: 'Slovakia' },
    { value: 'Slovenia (Slovenija)', text: 'Slovenia' },
    { value: 'Solomon Islands', text: 'Solomon Islands' },
    { value: 'Somalia (Soomaaliya)', text: 'Somalia' },
    { value: 'South Africa', text: 'South Africa' },
    { value: 'South Korea (대한민국)', text: 'South Korea' },
    { value: 'South Sudan (‫جنوب السودان‬‎)', text: 'South Sudan' },
    { value: 'Spain (España)', text: 'Spain' },
    { value: 'Sri Lanka (ශ්‍රී ලංකාව)', text: 'Sri Lanka' },
    { value: 'Sudan (‫السودان‬‎)', text: 'Sudan' },
    { value: 'Suriname', text: 'Suriname' },
    { value: 'Svalbard and Jan Mayen', text: 'Svalbard and Jan Mayen' },
    { value: 'Swaziland', text: 'Swaziland' },
    { value: 'Sweden (Sverige)', text: 'Sweden' },
    { value: 'Switzerland (Schweiz)', text: 'Switzerland' },
    { value: 'Syria (‫سوريا‬‎)', text: 'Syria' },
    { value: 'Taiwan (台灣)', text: 'Taiwan' },
    { value: 'Tajikistan', text: 'Tajikistan' },
    { value: 'Tanzania', text: 'Tanzania' },
    { value: 'Thailand (ไทย)', text: 'Thailand' },
    { value: 'Timor-Leste', text: 'Timor-Leste' },
    { value: 'Togo', text: 'Togo' },
    { value: 'Tokelau', text: 'Tokelau' },
    { value: 'Tonga', text: 'Tonga' },
    { value: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
    { value: 'Tunisia (‫تونس‬‎)', text: 'Tunisia' },
    { value: 'Turkey (Türkiye)', text: 'Turkey' },
    { value: 'Turkmenistan', text: 'Turkmenistan' },
    { value: 'Turks and Caicos Islands', text: 'Turks and Caicos Islands' },
    { value: 'Tuvalu', text: 'Tuvalu' },
    { value: 'U.S. Virgin Islands', text: 'U.S. Virgin Islands' },
    { value: 'Uganda', text: 'Uganda' },
    { value: 'Ukraine (Україна)', text: 'Ukraine' },
    { value: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', text: 'United Arab Emirates' },
    { value: 'United Kingdom', text: 'United Kingdom' },
    { value: 'United States', text: 'United States' },
    { value: 'Uruguay', text: 'Uruguay' },
    { value: 'Uzbekistan (Oʻzbekiston)', text: 'Uzbekistan' },
    { value: 'Vanuatu', text: 'Vanuatu' },
    { value: 'Vatican City (Città del Vaticano)', text: 'Vatican City' },
    { value: 'Venezuela', text: 'Venezuela' },
    { value: 'Vietnam (Việt Nam)', text: 'Vietnam' },
    { value: 'Wallis and Futuna (Wallis-et-Futuna)', text: 'Wallis and Futuna' },
    { value: 'Western Sahara (‫الصحراء الغربية‬‎)', text: 'Western Sahara' },
    { value: 'Yemen (‫اليمن‬‎)', text: 'Yemen' },
    { value: 'Zambia', text: 'Zambia' },
    { value: 'Zimbabwe', text: 'Zimbabwe' },
  ],
};
